import React, { Component } from "react"
import { HeadingInitial, Paragraph, Section, Quote } from "elements"

class WhyCS extends Component {
  render() {
    return (
      <div>
        <HeadingInitial>What Can Camps and Campers Do for Me?</HeadingInitial>

        <Section>
          <Paragraph>
            Camps and Campers is free to families and offers one of the most
            valuable tools available for finding a camp—the Camp Directors’
            Picks. Summer camps pay a fee to list their camp openings with us.
            Camp Families have FREE access to this information plus a few
            special features.
          </Paragraph>
          <Paragraph>
            By taking a few minutes to register with Camps and Campers, you will
            have the convenience of being able to automatically email your
            profile to camps you select by using our searching capabilities.
            Camps can also search for you, which means that camps can find you
            based on what you are looking for and their current openings.
          </Paragraph>
          <Quote>
            The most important step in the process of searching for a summer
            camp is selecting a camp that is right for you. Not all camps are
            the same!
          </Quote>
          <Paragraph>
            You should research each camp to determine if it meets your needs
            for the summer. For example, if you are interested in experiencing
            traditional New England camping, then a California Tennis camp may
            not be for you. Camps and Campers can help narrow your search and
            save you time.
          </Paragraph>
        </Section>
      </div>
    )
  }
}

export default WhyCS



// WEBPACK FOOTER //
// ./src/scenes/About/pages/whyCS.js